import { Menu } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  .ant-menu-item {
    padding: 0;
    height: 60px;
    .anticon {
      line-height: 30px;
    }
    .menu-custom-icon {
      width: 100%;
    }
    .menu-custom-title {
      font-size: 0.75rem;
    }
  }
`;
